export default __webpack_public_path__ + "static/media/305.98639f83.png";